import {Component, OnInit} from '@angular/core';
import {FadeZoomInTop} from '../../animations/fade-zoom-in-top.decorator';
import {AppCommunicationService} from '../../../+app-custom/services/app-communication.service';

@FadeZoomInTop()
@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.css']
})

export class MainLayoutComponent implements OnInit {
    loading = false;
    loadingText: string;

    constructor(
        private _appCommunicationService: AppCommunicationService
    ) {
    }

    ngOnInit() {
        this._appCommunicationService
            .loadingAnimation
            .subscribe(value => {
                this.loading = value;
            });

        this._appCommunicationService
            .loadingAnimationText
            .subscribe(val => {
                this.loadingText = val;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/app-layouts/main-layout.component.ts